import home from './home.vue';
import taskcenter from './taskcenter.vue';
import eventsReport from './eventsReport.vue';
import map from './component/map.vue';
import videoConnection from './videoConnection.vue';
import videoCall from './videoCall.vue';

let views = {
    home,   // 任务反馈入口
    taskcenter,
    eventsReport,
    map,
    videoConnection,
    videoCall
};

export default views;